import React from 'react';
import Tooltip from '../Tooltip';
import classNames from 'classnames';
import './RatingOption.less';

const RatingOption = ({ label, color, readOnly, onChange, withBorder, active, icon }) => {
    const renderComponent = (content) => {
        if (!label) return content;
        return <Tooltip title={label}>{content}</Tooltip>;
    };

    return renderComponent(
        <a
            className={classNames('rating-option', color, {
                active: active,
                readonly: readOnly,
                'with-border': withBorder,
            })}
            onClick={onChange}
        >
            <span className={icon}></span>
        </a>
    );
};

RatingOption.defaultProps = {
    withBorder: false,
    readOnly: false,
    color: '',
    label: null,
    active: false,
    onChange: () => {},
};
export default RatingOption;
